import { useQuery } from "@tanstack/react-query";
import { useAuth } from "../auth/AuthContext";
import { fetchProfile } from "../api/user";
import { LODGING_TOWNS } from "../data/lodgingTowns";
import { RESORTS_BY_ID } from "../data/resorts";
import { airbnbSearchUrl, bookingSearchUrl } from "../utils/lodgingLinks";

function closestResorts(town, n = 3) {
  return Object.entries(town.driveTimeMinutes)
    .sort((a, b) => a[1] - b[1])
    .slice(0, n)
    .map(([resortId, minutes]) => ({ resortId, minutes, name: RESORTS_BY_ID[resortId]?.name ?? resortId }));
}

function TownCard({ town }) {
  return (
    <div className="glass town-card">
      <div className="resort-card-head">
        <div>
          <div className="resort-name">{town.name}</div>
          <div className="sec-dek">{town.priceBand}</div>
        </div>
        <span className="pill">{town.state}</span>
      </div>
      <p className="town-blurb">{town.blurb}</p>
      <div className="town-drive-times">
        {closestResorts(town).map(({ resortId, minutes, name }) => (
          <span key={resortId} className="pill">
            {name} · {minutes} min
          </span>
        ))}
      </div>
      <div className="town-links">
        <a className="btn-accent" href={airbnbSearchUrl(town)} target="_blank" rel="noreferrer">
          Search Airbnb
        </a>
        <a className="pill" href={bookingSearchUrl(town)} target="_blank" rel="noreferrer">
          Search Booking.com
        </a>
      </div>
    </div>
  );
}

// Phase 2 — static price bands + drive time to each resort + Airbnb/Booking deep links.
// Not live pricing (see CLAUDE.md — that needs an OTA partner API, a business relationship not a build task).
export function LodgingTab() {
  const { user } = useAuth();
  const { data: profile } = useQuery({
    queryKey: ["profile", user?.userId],
    queryFn: () => fetchProfile(user.userId),
    enabled: !!user?.userId,
  });

  return (
    <section>
      <h2>Lodging</h2>
      <p className="sec-dek">
        5 base towns, static price bands and drive times — not live pricing, just a starting point for
        where to stay.
      </p>
      {profile?.homeLocation === "tahoe_local" && (
        <p className="sec-dek">You're already up here — this is mostly for the drive-up crowd.</p>
      )}
      <div className="resort-grid">
        {LODGING_TOWNS.map((town) => (
          <TownCard key={town.townId} town={town} />
        ))}
      </div>
    </section>
  );
}
